import { colors } from './colors';
export var customColors = {
    colorBorderWarning: colors.Y500,
    colorBorderSuccess: colors.Grn400,
    // baseColor: colors.B50,
    // colorTextLink: colors.B500,
    // baseRestColor: colors.B500,
    // baseHoverColor: colors.B600,
    // baseActiveColor: colors.B700,
    // baseDisabledColor: colors.G200,
    // darkRestColor: colors.G500,
    // darkHoverColor: colors.G600,
    darkActiveColor: colors.G800
};
//# sourceMappingURL=customColors.js.map